import dayjs from "dayjs";
import sortOnField from "./sortOnField";

export const sortFunction = (a, b, field, labels) => {
  return {
    STUDENT: sortOnField(
      a,
      b,
      (x) => `${x?.studentLastName?.toUpperCase()} ${x?.studentFirstName?.toUpperCase()}`,
      field.sortingDesc,
      (x) => dayjs(x.creationDate, "YYYY-MM-DDThh:mm:ssZ").unix()
    ),
    OSTEOPATA: sortOnField(
      a,
      b,
      (x) => x?.osteopath?.name?.toUpperCase(),
      field.sortingDesc,
      (x) => dayjs(Number(x.bookingDate)).unix()
    ),
    SCHOOL: sortOnField(
      a,
      b,
      (x) => x?.school?.toUpperCase(),
      field.sortingDesc,
      (x) => dayjs(x.creationDate, "YYYY-MM-DDThh:mm:ssZ").unix()
    ),
    DATE: sortOnField(
      a,
      b,
      (x) =>
        (x.creationDate
          ? dayjs(x.creationDate, "YYYY-MM-DDThh:mm:ssZ")
          : dayjs(Number(x.completionDate))
        ).unix(),
      !field.sortingDesc
    ),
    "BOOKING-DATE": sortOnField(
      a,
      b,
      (x) => dayjs(Number(x.bookingDate)).unix(),
      !field.sortingDesc
    ),
    STATUS: sortOnField(
      a,
      b,
      (x) => labels?.[`WELFARE_STATUS_${x?.status?.toUpperCase()}`] || x.status?.toUpperCase(),
      field.sortingDesc,
      (x) =>
        (x.creationDate
          ? dayjs(x.creationDate, "YYYY-MM-DDThh:mm:ssZ")
          : dayjs(Number(x.bookingDate))
        ).unix()
    ),
    PACKAGE: sortOnField(
      a,
      b,
      (x) => `${x?.packageSelected?.pack?.name || "-"}`,
      field.sortingDesc,
      (x) => `${x?.clinic?.name || "-"}`
    ),
    CENTER: sortOnField(
      a,
      b,
      (x) => `${x?.clinic?.name || "-"}`,
      field.sortingDesc,
      (x) => `${x?.completionDate || "-"}`
    ),
  }[field.sorting];
};

export const sortOptionToQuery = (sortOpt) => {
  const [sorting, sortingDesc] = sortOpt?.split("_");
  return { sortingDesc: sortingDesc === "AZ", sorting: sorting };
};
